// Tagesart eines Datums: Feiertag / Sonntag / Samstag / Werktag (bundesweite Feiertage).
const WOCHENTAGE = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

const ostersonntag = (jahr) => {
  const a = jahr % 19, b = Math.floor(jahr / 100), c = jahr % 100;
  const d = Math.floor(b / 4), e = b % 4;
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const monat = Math.floor((h + l - 7 * m + 114) / 31);
  const tag = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(jahr, monat - 1, tag));
};

const FESTE = [[1, 1], [5, 1], [10, 3], [12, 25], [12, 26]];

const feiertage = (jahr) => {
  const ostern = ostersonntag(jahr);
  const set = new Set(FESTE.map(([m, t]) => `${jahr}-${String(m).padStart(2, "0")}-${String(t).padStart(2, "0")}`));
  for (const off of [-2, 1, 39, 50]) {
    const d = new Date(ostern.getTime() + off * 86400000);
    set.add(d.toISOString().slice(0, 10));
  }
  return set;
};

/** { tag: "Samstag", art: "Samstag"|"Sonntag"|"Feiertag"|"Werktag", we: true|false } */
export const tagesart = (iso) => {
  const d = new Date(`${(iso || "").slice(0, 10)}T12:00:00Z`);
  if (Number.isNaN(d.getTime())) return { tag: "", art: "Werktag", we: false };
  const tag = WOCHENTAGE[d.getUTCDay()];
  if (feiertage(d.getUTCFullYear()).has(iso.slice(0, 10))) return { tag, art: "Feiertag", we: true };
  if (d.getUTCDay() === 0) return { tag, art: "Sonntag", we: true };
  if (d.getUTCDay() === 6) return { tag, art: "Samstag", we: true };
  return { tag, art: "Werktag", we: false };
};
